export const getLogParams = (
  pageType: 'Textbook' | 'OnlineClass' | 'DataPackage' | 'Question' | 'Thesis',
  questionType: 'PicSearch' | 'FullSearch' | 'TextSearch'
): {
  share_Type: number;
} => {
  const logMap = {
    Textbook: 4,
    OnlineClass: 5,
    DataPackage: 6,
    Question: 0,
    Thesis: 7 // 需求不需要此id，但不写会报错，暂定7
  };

  if (logMap[pageType]) {
    return {
      share_Type: logMap[pageType]
    };
  } else {
    const questionLogMap = {
      PicSearch: 1,
      FullSearch: 2,
      TextSearch: 3
    };
    return {
      share_Type: questionLogMap[questionType]
    };
  }
};
